import * as React from 'react';


interface BlockPreviewProps {
    previewImageUrl: string;
    button: React.ReactNode;
}

export const BlockPreview: React.FunctionComponent<BlockPreviewProps> = (props) => {
    return (
        <div
            className='block-preview'
            style={{backgroundImage: `url(${props.previewImageUrl})`}}
        >
            <div className='block-start-button-container'>
                {props.button}
            </div>
            <div className='block-preview-overlay'></div>
        </div>
    );
};
